// @ts-nocheck TODO

import {html, nothing} from "lit";
import {customElement, property, state} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";
import {initDrag, removeDrag} from "./drag_utils.js";
import {annotationStyles} from "./Annotation.styles.js";
import {annotationHighlightStyles} from "./AnnotationHighlight.styles.js";

import "./AnnotationHeader.js";
import "./AnnotationFooter.js";
import "../../common/controls-inputs/rich-text-editor/RichTextEditor.js";
import UI_MODES from "../ui_modes.js";
import {MobxLitElement} from "@adobe/lit-mobx";
import Data from "../../../main/data/index.js";
import {Editor} from "@tiptap/core";
import Integration from "../../../integrations/integration/index.js";

@customElement("pn-annotation-highlight")
export class AnnotationHighlight extends MobxLitElement {
	@property()  annotation = {
		comment: null,
		uuid:    null
	};
	@property() topic = {};
	@property() createdByName = "";
	@property() sortBy = "topic";
	@property() mode:       UI_MODES;
	@property() isEditable: boolean;

	@state() x = 0;
	@state() y = 0;

	static styles = [annotationStyles, annotationHighlightStyles];

	firstUpdated() {
		if (this.mode === UI_MODES.SIDEBAR_DRAG) {
			initDrag(this, {
				annotationUuid: this.annotation.uuid,
				type:           "highlight",
				quote:          this.annotation.selectedText
			});
		}
	}

	updated(changedProperties) {
		// TODO: improve conditional
		if (changedProperties.has("mode") && this.mode !== UI_MODES.SIDEBAR_DRAG) {
			// const prevMode = changedProperties.get("mode");
			// console.log(prevMode, this.mode);
			removeDrag(this.annotation.uuid);
		}
	}

	onBlurEditor = ({editor}: {editor: Editor | null}) => {
		const comment = editor.getHTML().trim();
		Data.annotation.update(this.annotation.uuid, Data.app.project.uuid, {comment});
	};

	render() {
		const canEditComment = this.mode === UI_MODES.SIDEBAR;

		return html`
			<div role="listitem"
				class="${classMap({
					"annotation-list-item":              true,
					"annotation-highlight":              true,
					"js-aa-topic-annotation":            true,
					"mode-sidebar":                      this.mode === UI_MODES.SIDEBAR,
					"mode-sidebar-drag":                 this.mode === UI_MODES.SIDEBAR_DRAG,
					"mode-sidebar-readonly":             this.mode === UI_MODES.SIDEBAR_READONLY,
					["integration-" + Integration.name]: Integration.isIntegration()
				})}"
				data-annotation-type="highlight"
				data-annotation-uuid="${this.annotation.uuid}"
				data-topic-uuid="${this.topic?.uuid}"
			>
				<pn-annotation-header
					.annotation=${this.annotation}
					.topic=${this.topic}
					sortBy=${this.sortBy}
				></pn-annotation-header>

				${((!this.annotation.comment || this.annotation.comment === "" || this.annotation.comment === "<p></p>") && !canEditComment)
					? nothing
					: html`<pn-rte
						.blurOnEnter="${true}"
						.constructEditorImmediately="${false}"
						.content="${this.annotation.comment}"
						.editable="${canEditComment}"
						id="${`pn-annotation-editor-${this.annotation.uuid}`}"
						.isAnnotationNote="${true}"
						.onBlur=${this.onBlurEditor}
						.placeholder="${"+ Note"}"
						.showToolbarOnFocusOnly="${true}"
					></pn-rte>`
				}

				<div class="text" lang="">“${this.annotation.selectedText}”</div>

				<pn-annotation-footer
					.annotation="${this.annotation}"
					.isEditable=${this.isEditable}
					.loadProjectTopics="${this.loadProjectTopics}"
					.mode="${this.mode}"
					.onClickPageLink="${(event) => this.onClickPageLink(event, this.annotation.uuid)}"
					.onDeleteAnnotation="${this.onDeleteAnnotation}"
					.onUpdateAnnotationTopic="${this.onUpdateAnnotationTopic}"
					.projects="${this.projects}"
					.projectTopicsUrl="${this.projectTopicsUrl}"
					.topics="${this.topics}"
				></pn-annotation-footer>
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-annotation-highlight": AnnotationHighlight;
	}
}
